<template>
  <div class="camera">
    <div class="pz">
      <camera device-position="back"
              flash="off"
              binderror="error"
              class="xj"></camera>
      <cover-view class="h3">请将身份证完整置于取景框内</cover-view>
      <cover-view class="bg"
                  v-if="zm">
        <cover-image src='https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_20941589788642440202018155722440camera-bg.png'
                     class="img"></cover-image>
      </cover-view>
      <cover-view class="bg"
                  v-else>
        <cover-image src='https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_3784158978870002620201815582026camera-bg-1.png'
                     class="img"></cover-image>
      </cover-view>
      <cover-view class="pza clear">
        <cover-image src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_114158978893974520201816219745camera.png"
                     style="width:112px;height:112px;margin: 50px auto;"
                     class="left"
                     @click="takePhoto()"
                     v-if="zm"></cover-image>
        <cover-image src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_114158978893974520201816219745camera.png"
                     style="width:112px;height:112px;margin: 50px auto;"
                     class="left"
                     @click="takePhoto1()"
                     v-else></cover-image>
      </cover-view>
    </div>
  </div>
</template>

<script>
import bus from '../../utils/bus.js'
export default {
  data() {
    return {
      zm: true,
    };
  },
  computed: {},
  mounted(options) {
    var that = this;
    console.log(options.id, "哈哈哦啊哦");
    if (options.id == 1) {
      that.zm = true;
    }
    if (options.id == 2) {
      that.zm = false;
    }
  },
  methods: {
    // 正面拍照
    takePhoto() {
      var that = this
      const ctx = wx.createCameraContext()
      wx.showLoading({
        title: '加载中',
      })
      ctx.takePhoto({
        quality: 'high',
        success: (res) => {
          console.log(res)
          var tempFilePaths = res.tempImagePath
          let data = sessionStorage.getItem('data')
          data.d["name"] = tempFilePaths;
          data.d["key"] = "zc_wxapplethc_" + new Date().getTime() + ".jpg";
          console.log(data, "------------------");
          wx.uploadFile({
            url: data.action, // 仅为示例，非真实的接口地址
            filePath: tempFilePaths,
            header: {
              'content-type': 'application/json'
            },
            name: 'file',
            formData: data.d,
            method: "post",
            success: function (res) {
              console.log(res.data, '正面拍照')
              var data = res.data;
              var obj = {
                idCodez: data.substring(data.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), data.indexOf('</Location>')),
                idcardIsImg: tempFilePaths,
                zm: true,
                hm: false
              }
              bus.$emit('upData', obj)
              wx.navigateBack({
                delta: 1
              })
              // var pages = getCurrentPages();
              // pages[pages.length - 2].setData({
              //     idCodez: data.substring(data.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), data.indexOf('</Location>')),
              //     idcardIsImg: tempFilePaths,
              //     zm: true,
              //     hm: false
              //   })


            },
            fail(res) {
              console.log(res);
            },
            complete: function (res) {
              wx.hideLoading();
            }
          })
        }
      })
    },
    // 反面拍照
    takePhoto1() {
      var that = this
      const ctx = wx.createCameraContext()
      wx.showLoading({
        title: '加载中',
      })
      ctx.takePhoto({
        quality: 'high',
        success: (res) => {
          console.log(res)
          var tempFilePaths = res.tempImagePath
          let data = sessionStorage.getItem('data')
          data.d["name"] = tempFilePaths;
          data.d["key"] = "zc_wxapplethc_" + new Date().getTime() + ".jpg";
          console.log(data, "------------------");
          wx.uploadFile({
            url: data.action, // 仅为示例，非真实的接口地址
            filePath: tempFilePaths,
            header: {
              'content-type': 'application/json'
            },
            name: 'file',
            formData: data.d,
            method: "post",
            success: function (res) {
              console.log(res.data, '反面拍照')
              var data = res.data;
              var obj = {
                idCodeb: data.substring(data.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), data.indexOf('</Location>')),
                idcardTheImg: tempFilePaths,
                zm: false,
                hm: false
              }
              bus.$emit('fanData', obj)
              wx.navigateBack({
                delta: 1
              })
              // var pages = getCurrentPages();
              // pages[pages.length - 2].setData({
              //     idCodez: data.substring(data.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), data.indexOf('</Location>')),
              //     idcardIsImg: tempFilePaths,
              //     zm: true,
              //     hm: false
              //   })


            },
            fail(res) {
              console.log(res);
            },
            complete: function (res) {
              wx.hideLoading();
            }
          })
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.camera {
  width: 100%;
  height: 100%;
  .pz {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
    position: fixed;
    .xj {
      display: inline-block;
      line-height: 442px;
      width: 698px;
      height: 442px;
      position: fixed;
      top: 180px;
      left: 26px;
    }
    .h3 {
      width: 400px;
      height: 46px;
      line-height: 46px;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 23px;
      margin: 0 auto;
      text-align: center;
      font-size: 28px;
      color: white;
      position: fixed;
      top: 710px;
      left: 175px;
    }
    .bg {
      width: 698px;
      height: 442px;
      position: fixed;
      top: 180px;
      left: 26px;
      image {
        width: 100%;
        height: 100%;
      }
    }
    .pza {
      width: 750px;
      height: 197px;
      background-color: rgba(0, 0, 0, 0.4);
      position: fixed;
      bottom: 0;
      left: 0;
      image {
        display: block;
        position: relative;
        z-index: 999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/camera/index.vue